import styled from 'styled-components';

export const FlexParentBlock = styled.div`
  display: flex;
`;

export const HorizontalCenterBlock = styled.div`
  display: flex;
  justify-content: center;
`;

export const VerticalCenterBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const ColumnBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const VerticalCenterLeftBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
`;

export const HorizontalCenterColumnBlock = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const VerticalHorizontalCenterColumnBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const VerticalHorizontalCenterBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpaceBetweenBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TextCenterBlock = styled.div`
  text-align: center;
`;

export const TextLeftBlock = styled.div`
  text-align: left;
`;

export const ShortSettingsBlock = styled.div`
  max-width: 468px;
  flex-grow: 1;
`;

export const NotifyLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;

export const CommonLink = styled.a`
  color: ${(props) => props.theme.colors.brand};
`;
